import { Outlet, useLocation } from '@tanstack/react-router';
import { getConnectionName } from '@/helpers/auth';
import { useAuthenticatedUserClaims } from '@/routes/_authenticated.hooks';
import { useLogoutHandler } from './hooks/useLogoutHandler';
import { SessionExceptionModal, type SessionExceptionModalReason } from './SessionExceptionModal';

export function BlockedLogout({ reason }: { reason: SessionExceptionModalReason }) {
  const location = useLocation();
  const userClaims = useAuthenticatedUserClaims();

  let loginConnection: string | undefined;
  let loginHint: string | undefined;
  if (reason === 'expired') {
    const subjectClaim = userClaims.sub ?? '';
    loginConnection = getConnectionName(subjectClaim);
    loginHint = userClaims.email;
  }

  const logout = useLogoutHandler({
    aerr: undefined,
    sso_connection: loginConnection,
    sso_login_hint: loginHint,
    return_to: location.pathname,
  });

  return (
    <>
      <SessionExceptionModal reason={reason} onAccept={logout} />
      <Outlet />
    </>
  );
}
